/**
 * @file Discover album folder start for generic purposes (fallback).
 */

import React from 'react';
import PropTypes from 'prop-types';

import { getAsset } from '../../../util/assets';
import { albumFolderAnyoneCanUploadEnabled } from '../../../util/album-folder';
import Button from '../../global/Button';
import OnboardingLayoutContentNarrow from '../../../apps/temp/views/onboarding/OnboardingLayout/components/OnboardingLayoutContentNarrow';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  onGetStarted: PropTypes.func,
};

const DiscoverAlbumFolderStartWeddings = ({ albumFolder, onGetStarted }) => {
  const anyoneCanUpload = albumFolderAnyoneCanUploadEnabled(albumFolder);
  return (
    <OnboardingLayoutContentNarrow>
      <div className="d-flex flex-column align-items-center justify-content-center">
        <h4 className="mb-1 text-center">Welcome to</h4>
        <h2 className="text-black mb-2 text-center">{albumFolder.name}!</h2>
        <img
          width="76"
          src={getAsset('/waldo-top-hat.png')}
          alt="Waldo top hat"
          className="mb-2"
        />
      </div>
      <p className="text-center mb-0">
        Join the gallery, provide a selfie and I’ll find and deliver all your
        photos!{' '}
      </p>
      {anyoneCanUpload && (
        <p className="text-center mt-2 mb-0">
          You can add all the photos you take, post your favorite pics and order
          prints all from the app!
        </p>
      )}
      <Button onClick={onGetStarted} className="mt-3" btnBlock>
        Join The Event
      </Button>

      <div className="d-flex mt-1">
        <a href="/terms" target="_blank" className="m-auto text-xs">
          Terms &amp; Conditions
        </a>
      </div>
    </OnboardingLayoutContentNarrow>
  );
};

DiscoverAlbumFolderStartWeddings.propTypes = propTypes;

export default DiscoverAlbumFolderStartWeddings;
